import { render, staticRenderFns } from "./FourMatView.vue?vue&type=template&id=14c3cb76&scoped=true&"
import script from "./FourMatView.vue?vue&type=script&lang=js&"
export * from "./FourMatView.vue?vue&type=script&lang=js&"
import style0 from "./FourMatView.vue?vue&type=style&index=0&id=14c3cb76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c3cb76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
